(function () {
  var SECTION = 'amz-search-suggest';
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function setup(form) {
    if (form.__amzs) return; form.__amzs = true;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var box = document.createElement('div');
    box.className = 'amzs'; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    var ctrl = null, last = '', active = -1, cache = {};
    function items() { return Array.prototype.slice.call(box.querySelectorAll('[data-amzs-item]')); }
    function show() { if (box.innerHTML.trim()) { box.hidden = false; form.classList.add('is-open'); } }
    function hide() { box.hidden = true; form.classList.remove('is-open'); active = -1; }
    function render(html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var panel = tmp.querySelector('[data-amzs-panel]');
      box.innerHTML = panel ? panel.outerHTML : '';
      active = -1; show();
    }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { box.innerHTML = ''; hide(); return; }
      if (q === last) { show(); return; }
      last = q;
      if (cache[q]) { render(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      box.classList.add('is-loading');
      var url = '/search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&section_id=' + SECTION;
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        box.classList.remove('is-loading');
        if (input.value.trim() !== q) return;
        cache[q] = html; render(html);
      }).catch(function () { box.classList.remove('is-loading'); });
    }, 200);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) { if (box.innerHTML.trim()) show(); else run(); } });
    input.addEventListener('keydown', function (e) {
      var list = items();
      if (e.key === 'Escape') { hide(); return; }
      if (box.hidden || !list.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = e.key === 'ArrowDown' ? (active + 1) % list.length : (active <= 0 ? list.length - 1 : active - 1);
        list.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        list[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault(); window.location.href = list[active].href;
      }
    });
    document.addEventListener('pointerdown', function (e) { if (!form.contains(e.target)) hide(); });
  }
  function all() { document.querySelectorAll('form.amzh__search').forEach(setup); }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();
